import React from 'react'
import CardHeader from '@material-ui/core/CardHeader';
import { makeStyles } from '@material-ui/core/styles';
import { useCardStyles } from '../../App';
import theme from '../../theme';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';
import { UserMinimal } from '../../@types';
import { AccountCircle } from '@material-ui/icons';

const useStyles = makeStyles({
	title: {
		color: theme.palette.common.black,
        fontWeight: 500,
        marginLeft: '5px'
	},
	avatar: {
		backgroundColor: theme.palette.primary.light,
        marginLeft: '10px'
	},
	action: {
		padding: '20px 1vw 0px 0px',
	},
});

export type UserCardHeaderProps = {
	user: UserMinimal
}

export const UserCardHeader = (props: UserCardHeaderProps) => {
	const classes = useStyles();

	return (
		<>
			<CardHeader
				classes={{
					title: classes.title,
					action: classes.action,
				}}
				avatar={
					<Avatar aria-label={`${props.user.firstName}`} className={classes.avatar}>
						<AccountCircle />
					</Avatar>
				}
				title={
					<>
						<Typography variant='h6' className={classes.title}>
							{props.user.firstName} {props.user.lastName}
						</Typography>
					</>
				}
			/>
		</>
	);
};